
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 140070"}},[_c('g',{attrs:{"data-name":"Worried Face"}},[_c('circle',{attrs:{"data-name":"Ellipse 6437","cx":"14.02","cy":"14.02","fill":"#fdca47","r":"14.02","transform":"translate(.721 1.127)"}}),_c('g',{attrs:{"data-name":"Group 139677","transform":"translate(8.174 11.212)","fill":"#664100"}},[_c('ellipse',{attrs:{"data-name":"Ellipse 6438","cx":"1.852","cy":"2.669","rx":"1.852","ry":"2.669","transform":"translate(9.431)"}}),_c('ellipse',{attrs:{"data-name":"Ellipse 6439","cx":"1.852","cy":"2.669","rx":"1.852","ry":"2.669"}})]),_c('g',{attrs:{"data-name":"Group 139680"}},[_c('g',{attrs:{"data-name":"Group 139678"}},[_c('path',{attrs:{"data-name":"Path 154327","d":"M24.12 9.419a.7.7 0 00-.609-.46c-2.544-.175-3.52-.891-5.164-2.953a.69.69 0 00-.975-.111.7.7 0 00-.1.984c1.781 2.235 3.093 3.267 6.159 3.478a.689.689 0 00.733-.652.709.709 0 00-.044-.286z","fill":"#664100"}})]),_c('g',{attrs:{"data-name":"Group 139679"}},[_c('path',{attrs:{"data-name":"Path 154328","d":"M5.361 9.419a.7.7 0 01.609-.46c2.544-.175 3.521-.891 5.164-2.953a.69.69 0 01.975-.111.7.7 0 01.1.984c-1.781 2.235-3.093 3.267-6.159 3.478a.688.688 0 01-.732-.652.7.7 0 01.043-.286z","fill":"#664100"}})])]),_c('path',{attrs:{"data-name":"Path 154329","d":"M10.902 24.011a.315.315 0 01-.441-.339 4.36 4.36 0 018.561 0 .314.314 0 01-.441.339 10.813 10.813 0 00-7.679 0z","fill":"#664100"}})])])])
          )
        }
      }
    